var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row terms-box" }, [
      _c("div", { staticClass: "col-lg-12" }, [
        _vm.isLoading
          ? _c("div", { staticClass: "loading-container" }, [
              _c("div", { staticClass: "loading-spinner" }),
              _c("p", [_vm._v("Loading...")]),
            ])
          : _vm.error
          ? _c("div", { staticClass: "error-container" }, [
              _c("h1", [_vm._v("An error occurred.")]),
              _c("p", [_vm._v(_vm._s(_vm.error))]),
              _c(
                "button",
                {
                  staticClass: "retry-button",
                  on: { click: _vm.fetchTermsContent },
                },
                [_vm._v("Retry")]
              ),
            ])
          : _c("div", {
              staticClass: "terms-content",
              domProps: { innerHTML: _vm._s(_vm.termsContent) },
            }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }